import { render, staticRenderFns } from "./galleryDetail.vue?vue&type=template&id=a6bd03d2&scoped=true"
import script from "./galleryDetail.vue?vue&type=script&lang=js"
export * from "./galleryDetail.vue?vue&type=script&lang=js"
import style0 from "./galleryDetail.vue?vue&type=style&index=0&id=a6bd03d2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6bd03d2",
  null
  
)

export default component.exports